<app-mat-data-grid
    class="page-data-grid"
    [formValid]="isValid"
    [(dataSource)]="people"
    [displayedColumns]="[
        'first',
        'last',
        'content',
        'stuff',
        'misc',
        'garbage',
        'trash',
        'dumpster'
    ]"
    [columnNames]="[
        'First',
        'Last',
        'Content',
        'Stuff',
        'Miscellanious',
        'Garbage',
        'Trash',
        'Dumpster'
    ]"
    [editDefinition]="{
        first: firstName,
        last: lastName
    }"
    [pageSizeOptions]="[5, 10, 15]"
    [objectBluePrint]="{ first: 'john', last: 'doe'}"
    >
</app-mat-data-grid>

<ng-template let-element #firstName>
    <span class="textInput">
        <input
        type="text"
        [(ngModel)]="element.first"
    />
    </span>
</ng-template>

<ng-template let-element #lastName>
    <input
        type="text"
        [(ngModel)]="element.last"
    />
</ng-template>

